/**
 * Parses DeliveryTypeId string which can be a single number or CSV of numbers.
 * Returns the first valid number if found, otherwise null.
 */
export const parseDeliveryTypeId = (deliveryTypeId: string | null | undefined): number | null => {
    if (!deliveryTypeId) return null;

    const trimmed = String(deliveryTypeId).trim();

    // Check if it's a single number
    const singleValue = parseInt(trimmed, 10);
    if (!isNaN(singleValue) && singleValue.toString() === trimmed) {
        return singleValue;
    }

    // Check if it's CSV - take the first valid number
    const parts = trimmed
        .split(",")
        .map(p => p.trim())
        .filter(p => p.length > 0);
    for (const part of parts) {
        const value = parseInt(part, 10);
        if (!isNaN(value) && value.toString() === part) {
            return value;
        }
    }

    return null;
};

/**
 * Parses DeliveryTypeId string which can be a single number or CSV of numbers.
 * Returns a list of all valid numbers found.
 */
export const parseDeliveryTypeIdList = (deliveryTypeId: string | null | undefined): Array<number> => {
    const result: Array<number> = [];

    if (!deliveryTypeId) return result;

    const trimmed = String(deliveryTypeId).trim();

    // Check if it's a single number
    const singleValue = parseInt(trimmed, 10);
    if (!isNaN(singleValue) && singleValue.toString() === trimmed) {
        result.push(singleValue);
        return result;
    }

    // Check if it's CSV - collect all valid numbers
    const parts = trimmed
        .split(",")
        .map(p => p.trim())
        .filter(p => p.length > 0);
    for (const part of parts) {
        const value = parseInt(part, 10);
        if (!isNaN(value) && value.toString() === part) {
            result.push(value);
        }
    }

    return result;
};
